import { render, staticRenderFns } from "./commonuserjk.vue?vue&type=template&id=a12ce630&"
import script from "./commonuserjk.vue?vue&type=script&lang=js&"
export * from "./commonuserjk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports